import React from "react";
import {
  LucideActivity,
  LucideCircleCheckBig,
  LucideCircleX,
  LucideClock,
  LucidePlus,
  LucideUsers,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

import Button from "../../components/dashboard/Button";

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="p-6 space-y-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        Trending Metrics
      </h2>

      <div className="grid grid-cols-4 gap-4">
        <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-4">
          <LucideCircleCheckBig className="w-4 h-4 text-green-500 absolute top-4 right-4" />
          <div className="text-sm font-medium">Live PSPs</div>
          <div className="text-2xl font-bold text-green-500">2</div>
        </div>

        <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-4">
          <LucideClock className="w-4 h-4 text-yellow-500 absolute top-4 right-4" />
          <div className="text-sm font-medium">Suspended PSPs</div>
          <div className="text-2xl font-bold text-yellow-500">2</div>
        </div>

        <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-4">
          <LucideCircleX className="w-4 h-4 text-red-500 absolute top-4 right-4" />
          <div className="text-sm font-medium">Failed PSPs</div>
          <div className="text-2xl font-bold text-red-500">2</div>
        </div>

        <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-4">
          <LucideUsers className="w-4 h-4 text-blue-500 absolute top-4 right-4" />
          <div className="text-sm font-medium">Total Users</div>
          <div className="text-2xl font-bold text-blue-500">2</div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-8">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-2xl font-bold text-gray-900">Recents</h2>
            <Button
              onClick={() => {
                navigate("/launchpad/psp/create");
              }}
            >
              <div className="flex items-center gap-2">
                <LucidePlus className="w-4 h-4" />
                <span>Create PSP</span>
              </div>
            </Button>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-1">
              <div>Cancer Drug Program</div>
              <div className="flex items-center gap-2">
                <p className="flex items-center gap-2 text-xs bg-green-200 rounded-full px-2 py-1 text-green-800">
                  <LucideCircleCheckBig className="w-3 h-3" />
                  <span>Live</span>
                </p>
                <p className="text-sm text-gray-500">145 Users</p>
              </div>
              <div className="text-sm text-gray-600">Created by: Dr. Smith</div>
              <div className="text-sm text-gray-600">Modified: 2024-01-20</div>
            </div>

            <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-1">
              <div>Cancer Drug Program</div>
              <div className="flex items-center gap-2">
                <p className="flex items-center gap-2 text-xs bg-yellow-200 rounded-full px-2 py-1 text-yellow-800">
                  <LucideClock className="w-3 h-3" />
                  <span>Suspended</span>
                </p>
                <p className="text-sm text-gray-500">145 Users</p>
              </div>
              <div className="text-sm text-gray-600">Created by: Dr. Smith</div>
              <div className="text-sm text-gray-600">Modified: 2024-01-20</div>
            </div>

            <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-1">
              <div>Cancer Drug Program</div>
              <div className="flex items-center gap-2">
                <p className="flex items-center gap-2 text-xs bg-red-200 rounded-full px-2 py-1 text-red-800">
                  <LucideCircleX className="w-3 h-3" />
                  <span>Failed</span>
                </p>
                <p className="text-sm text-gray-500">145 Users</p>
              </div>
              <div className="text-sm text-gray-600">Created by: Dr. Smith</div>
              <div className="text-sm text-gray-600">Modified: 2024-01-20</div>
            </div>

            <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-1">
              <div>Cancer Drug Program</div>
              <div className="flex items-center gap-2">
                <p className="flex items-center gap-2 text-xs bg-green-200 rounded-full px-2 py-1 text-green-800">
                  <LucideCircleCheckBig className="w-3 h-3" />
                  <span>Live</span>
                </p>
                <p className="text-sm text-gray-500">145 Users</p>
              </div>
              <div className="text-sm text-gray-600">Created by: Dr. Smith</div>
              <div className="text-sm text-gray-600">Modified: 2024-01-20</div>
            </div>
          </div>
        </div>

        <div className="col-span-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-1">
            Updates
          </h2>

          <div className="border border-gray-200 rounded-md p-6 bg-white relative flex flex-col items-start gap-1">
            <div className="flex items-start gap-4">
              <div>
                <LucideActivity className="w-4 h-4 text-green-500" />
              </div>
              <div>
                <p className="text-sm text-gray-900">
                  Cancer Drug Program deployed successfully
                </p>
                <p className="text-xs text-gray-500 mt-1">2 hours ago</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
